import React from 'react'
import {createApi} from '../../../services/api'

export const WidgetApiContext = React.createContext<ReturnType<typeof createApi>>(null)

export const useApi = () => React.useContext<ReturnType<typeof createApi>>(WidgetApiContext)
